import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";

import MyDrawer from "../../../components/Admin/Drawer";
import Files from "./Files";
import { FileProvider } from "../../../components/File/FileContext";
import { TypeProvider } from "../../../components/File/TypeContext";
import { useStyles, theme } from "../theme.js";

const FileAdminPage = (props) => {
  const classes = useStyles();

  return (
    <FileProvider>
      <TypeProvider>
        <ThemeProvider theme={theme}>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
            anchor="left"
          >
            <MyDrawer></MyDrawer>
          </Drawer>
          <div className={classes.adminMain}>
            <Header></Header>
            <Files></Files>
          </div>
          <CssBaseline></CssBaseline>
        </ThemeProvider>
      </TypeProvider>
    </FileProvider>
  );
};

export default FileAdminPage;
